import React, { useLayoutEffect, useState, createContext, useContext } from "react";
import { useParams, Navigate } from "react-router-dom";
import { EDCFlowProvider } from "@smvtech/x-flux";
import { initEDCFlow } from "../config";

type EDCFlowContextValues = {
	tncAccepted: boolean;
	setTncAccepted: (accepted: boolean) => void;
	isSavingAnswer: boolean;
	setIsSavingAnswer: (saving: boolean) => void;
};

const EDCFlowContextInstance = createContext<EDCFlowContextValues | undefined>(undefined);

const EDCFlowContextWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [tncAccepted, setTncAccepted] = useState(false);
	const [isSavingAnswer, setIsSavingAnswer] = useState(false);

	const contextValue: EDCFlowContextValues = {
		tncAccepted,
		setTncAccepted,
		isSavingAnswer,
		setIsSavingAnswer
	};

	return <EDCFlowContextInstance.Provider value={contextValue}>{children}</EDCFlowContextInstance.Provider>;
};

export const EDCFlowContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { orderId } = useParams<{ orderId: string }>();

	useLayoutEffect(() => {
		initEDCFlow();
	}, [orderId]);

	if (!orderId) {
		return <Navigate to="/notfound" replace={true} />;
	}

	return (
		<EDCFlowProvider orderId={orderId}>
			<EDCFlowContextWrapper>{children}</EDCFlowContextWrapper>
		</EDCFlowProvider>
	);
};

export const useEDCFlowContext = () => {
	const context = useContext(EDCFlowContextInstance);
	if (!context) {
		throw new Error("useEDCFlowContext must be used within EDCFlowContextProvider");
	}
	return context;
};
